var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "infinite-scroll",
          rawName: "v-infinite-scroll",
          value: _vm.load,
          expression: "load",
        },
      ],
      staticClass: "yxt-category-tree",
    },
    [
      !_vm.hideSearch
        ? _c("yxt-input", {
            staticClass: "yxt-category-tree-search",
            attrs: {
              searchable: "",
              placeholder: _vm.placeholder,
              maxlength: 20,
              clearable: "",
            },
            on: { search: _vm.search },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          })
        : _vm._e(),
      _vm.selectedDirectoryRange
        ? _c(
            "yxt-checkbox",
            {
              style: _vm.hideSearch ? "margin-top: 0;" : "margin-top: 16px;",
              model: {
                value: _vm.selectedIncludeChildDir,
                callback: function ($$v) {
                  _vm.selectedIncludeChildDir = $$v
                },
                expression: "selectedIncludeChildDir",
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.text1))]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "yxt-category-tree-content",
          style:
            _vm.hideSearch && !_vm.selectedDirectoryRange
              ? "margin-top: 0; height: 100%;"
              : "",
        },
        [
          _vm.empty
            ? _c("yxt-empty")
            : _c("tree-node", {
                attrs: {
                  activeId: _vm.activeId,
                  checkType: this.mode === 1 ? 0 : _vm.checkType,
                  rootType: _vm.rootType,
                  mode: _vm.mode,
                  limit: _vm.limit,
                  settings: _vm.settings,
                  sort: _vm.sort,
                  deleteFunc: _vm.deleteFunc,
                  "handle-click": _vm.handleClick,
                  "handle-check": _vm.handleCheck,
                  showForm: _vm.showForm,
                  showExport: _vm.showExport,
                  checkedIds: _vm.checkedList,
                  parentResetCheckChild: _vm.resetCheckChild,
                  data: _vm.data,
                  searchState: !!_vm.keyword,
                  multiple: _vm.multiple && _vm.mode === 2,
                  pnodeId: (_vm.treeData && _vm.treeData.nodeId) || "0",
                  index: 0,
                  expandAll: _vm.expandALL,
                  containChildren: false,
                  expandedDefault: true,
                  sortable: _vm.sortable && _vm.mode === 1,
                  firstModifiable: _vm.mode === 1 ? _vm.firstModifiable : false,
                  modifiable: _vm.mode === 1 ? _vm.modifiable : {},
                  "get-cate-children": _vm.getCateChildren,
                  nodeRender: _vm.nodeRender,
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }